import * as Types from '../../../@types/graphql-types';

import { NewTitleGraphqlFragment } from '../fragments/NewTitle.fragment';
import gql from 'graphql-tag';
import { NewTitleGraphqlFragmentDoc } from '../fragments/NewTitle.fragment';
export type GetNewTitlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
	date: Types.Scalars['Date'];
	language: Types.Scalars['Language'];
	filter?: Types.Maybe<Types.TitleFilter>;
	after?: Types.Maybe<Types.Scalars['String']>;
	first?: Types.Scalars['Int'];
	profile?: Types.Maybe<Types.PosterProfile>;
	format?: Types.Maybe<Types.ImageFormat>;
	priceDrops: Types.Scalars['Boolean'];
	platform: Types.Platform;
	bucketType?: Types.Maybe<Types.NewDateRangeBucket>;
	pageType?: Types.NewPageType;
	showDateBadge: Types.Scalars['Boolean'];
	availableToPackages?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;

export type GetNewTitlesQuery = { __typename?: 'Query' } & {
	newTitles: { __typename?: 'NewTitlesConnection' } & Pick<Types.NewTitlesConnection, 'totalCount'> & {
			edges?: Types.Maybe<Array<{ __typename?: 'NewTitlesEdge' } & NewTitleGraphqlFragment>>;
			pageInfo: { __typename?: 'PageInfo' } & Pick<
				Types.PageInfo,
				'endCursor' | 'hasPreviousPage' | 'hasNextPage'
			>;
		};
};

export const GetNewTitlesDocument = gql`
	query GetNewTitles(
		$country: Country!
		$date: Date!
		$language: Language!
		$filter: TitleFilter
		$after: String
		$first: Int! = 10
		$profile: PosterProfile
		$format: ImageFormat
		$priceDrops: Boolean!
		$platform: Platform!
		$bucketType: NewDateRangeBucket
		$pageType: NewPageType! = NEW
		$showDateBadge: Boolean!
		$availableToPackages: [String!]
	) {
		newTitles(
			country: $country
			date: $date
			filter: $filter
			after: $after
			first: $first
			priceDrops: $priceDrops
			bucketType: $bucketType
			pageType: $pageType
		) {
			totalCount
			edges {
				...NewTitleGraphql
			}
			pageInfo {
				endCursor
				hasPreviousPage
				hasNextPage
			}
		}
	}
	${NewTitleGraphqlFragmentDoc}
`;
